import React, {ReactElement, useEffect, useState} from 'react';
import {BackButtonAction} from '../../../core/utils/string.util';
import {
  setAppBarTitle,
  setBackNavAction,
  setBackNavEnabled,
  setLoaderRunning,
  setPaymentEnableButton,
} from '../../../redux/globalSlice';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import {useHistory, useLocation} from 'react-router-dom';
import {
  getAccessToken,
  getLmrChecked,
  getMetadata,
  getOrderResp,
  getStoreCode,
  getStoreInformation,
  getUser,
  setCheckSum,
} from '../../../core/localstorage-data';
import {
  checkTransactionStatus,
  fetchOrder,
  generateInvoice,
  invoiceGeneratedError,
  invoiceGeneratedLoading,
  invoiceGeneratedResponse,
  orderResponse,
  paymentStatus,
  paymentStatusError,
  paymentStatusLoading,
  resetInvoiceResponse,
  resetPaymentStatus,
  resetTransactionResponse,
  transactionStatusError,
  transactionStatusResponse,
  transactionStatusResponseLoading,
  verifyPaymentStatus,
} from '../../../redux/orderSlice';
import {paymentRecieveMoengageCall} from '../../../lib/moengageCall';
import cogoToast from 'cogo-toast';
import InformationToast from '../../../components/notifications/InformationToast';
import {failedPayment, finalOrderPayment, purchaseEventGA} from '../../../lib/tagmanager';
let paymentAttempCounter = 0;
let checksum: string | null;
let orderId: string | null;
let paymentAttemptTimer = 0;
let BAG_PRICE = 0;
let paymentAttemptStatus = true;
type PriceDetails = {
  totalMRP: number;
  promoDiscountAmount: number;
  totalAmount: number;
  lmrRewardsPrice?: number;
};

const ProcessPayment = (): ReactElement => {
  const dispatch = useAppDispatch();
  const search = useLocation().search;
  const accessToken = getAccessToken();
  const storeCode = `0${getStoreInformation().store_code}`;
  const navigate = useHistory();
  const [priceDetails, setPriceDetails] = useState<PriceDetails | null>(null);
  const metaData = getMetadata();
  const customerProfileData = getUser();
  const [lmrRewardPoints, setLmrRewardPoints] = useState(
    customerProfileData.pointsAvailable * 0.6,
  );
  const card_number = getUser().cardNumber;
  const storeId = getStoreCode();
  const currentOrderResp = getOrderResp();

  const verifyPaymentResp = useAppSelector(paymentStatus);
  const paymentStatusLoaded = useAppSelector(paymentStatusLoading);
  const orderResp = useAppSelector(orderResponse);
  const errorInPaymentStatus = useAppSelector(paymentStatusError);
  const invoiceResponse = useAppSelector(invoiceGeneratedResponse);
  const invoiGenerationError = useAppSelector(invoiceGeneratedError);
  const invoiceLoading = useAppSelector(invoiceGeneratedLoading);
  const transactionStatusResp = useAppSelector(transactionStatusResponse);
  const transactionStatusLoading = useAppSelector(
    transactionStatusResponseLoading,
  );
  const transactionStatusRespError = useAppSelector(transactionStatusError);

  useEffect(() => {
    dispatch(setAppBarTitle('Process Payment'));
    dispatch(setBackNavEnabled(false));

    return () => {
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
      dispatch(setBackNavAction(undefined));
    };
  }, []);

  // useEffect(() => {
  //   const parameters = {
  //     accessToken: accessToken,
  //     payload: {
  //       storeCode: storeCode,
  //       cardNumber: card_number,
  //       storeKeyId: storeId,
  //     },
  //   };
  //   dispatch(fetchOrder(parameters));
  // }, []);

  useEffect(() => {
    if (orderResp !== null) {
      const priceDetail = getPriceDetails(orderResp);
      setPriceDetails({
        totalMRP: priceDetail.totalMRP,
        promoDiscountAmount: priceDetail.promoDiscountAmount,
        totalAmount: priceDetail.totalAmount,
      });
      // if (userType === 'employee') {
      //   if (
      //     orderResp.paymentStatus !== undefined &&
      //     orderResp.paymentStatus === true
      //   ) {
      //     if (showPaymentStatus === 0) {
      //       setOrderButtonEnable(false);
      //       setDisableQrLink(true);
      //       setDisablePaymentLink(true);
      //       setDisableCheckbox(true);
      //       cogoToast.success(
      //         <InformationToast
      //           title="Payment Status Pending"
      //           description={
      //             'Look like payment status of last order is still pending.Please click payment status button to check the status '
      //           }
      //         />,
      //         {
      //           hideAfter: 10,
      //           renderIcon: () => {
      //             return null;
      //           },
      //         },
      //       );
      //       showPaymentStatus++;
      //     }
      //   }
      // }
      //console.log(orderResp?.linkId);
    } else {
      console.log('----> orderresp not there');
    }
  }, [orderResp]);

  const bagMetaData = metaData.find(
    (obj: {name: string}) => obj.name === 'bag-price',
  );

  if (bagMetaData) {
    BAG_PRICE = bagMetaData.value;
  }

  function getPriceDetails(resp: any, bool?: boolean) {
    let totalMRP = 0;
    let promoDiscountAmount = 0;
    let bagPrice = 0;
    let couponDiscount = 0;
    orderResp &&
      orderResp.itemList &&
      orderResp.itemList.forEach(item => {
        totalMRP += item.sellPrice;
        promoDiscountAmount += item && item.promoDiscountAmount;
      });
    if (orderResp && orderResp.carryBagItem) {
      bagPrice = BAG_PRICE * orderResp.carryBagItem.quantity;
    }
    orderResp &&
      orderResp.itemList &&
      orderResp.itemList.forEach(item => {
        if (item.couponDiscountAmount) {
          couponDiscount += item.couponDiscountAmount;
        } else couponDiscount = 0;
      });
    let lmrRewardsPrice = 0;
    if (bool) {
      lmrRewardsPrice = lmrRewardPoints;
    } else {
      lmrRewardsPrice = 0;
    }
    let totalAmount =
      orderResp && orderResp.itemList
        ? orderResp.itemList.reduce((prevAmount, item) => {
            return prevAmount + item.extSellPrice;
          }, 0)
        : 0;
    totalAmount = totalAmount + bagPrice - lmrRewardsPrice;

    return {
      totalMRP,
      promoDiscountAmount,
      totalAmount,
      lmrRewardsPrice,
    };
  }

  useEffect(() => {
    let orderId = new URLSearchParams(search).get('orderId');
    if (!orderId && currentOrderResp !== null) {
      orderId = currentOrderResp.orderId;
    }
    if (invoiceResponse !== null) {
      if (invoiceResponse.txnStatus === 'completed') {
        if (priceDetails?.totalAmount != null) {
          finalOrderPayment(priceDetails.totalAmount.toString());
        }
        purchaseEventGA(
          invoiceResponse.txnNumber,
          currentOrderResp,
        );
        navigate.push('/checkout/confirm');
      } else {
        if (invoiceResponse.statusCode === '1053') {
          navigate.push('/checkout/confirm');
        }

        if (
          invoiceResponse.statusCode === '1054' ||
          invoiceResponse.statusCode === '1055' ||
          invoiceResponse.statusCode === '1056' ||
          invoiceResponse.statusCode === '1057'
        ) {
          navigate.push('/checkout/payment_error');
        } else {
          const parameters = {
            accessToken,
            payload: {
              storeCode: storeCode,
              orderId: orderId,
            },
          };
          dispatch(checkTransactionStatus(parameters));
          // call status check api here
        }
      }
      //  dispatch(resetInvoiceResponse());
      // dispatch(resetTransactionResponse());
    }
    if (invoiGenerationError !== null) {
      if (invoiGenerationError.message != '' && invoiceLoading === false) {
        if (invoiGenerationError.error === 'lmrPointsRedumption') {
          navigate.push('/checkout/payment_error');
        } else {
          navigate.push('/checkout/confirm');
        }

        //dispatch(resetInvoiceResponse());
        //dispatch(resetTransactionResponse());
      }
    }
  }, [invoiceResponse, invoiGenerationError, invoiceLoading]);

  useEffect(() => {
    if (transactionStatusResp) {
      if (transactionStatusResp.statusCode === '200') {
        //redirect to confirm page
        if (priceDetails?.totalAmount != null) {
          finalOrderPayment(priceDetails.totalAmount.toString());
        }
        navigate.push('/checkout/confirm');
      } else {
        navigate.push('/checkout/confirm');
      }

      //  dispatch(resetInvoiceResponse());
      //  dispatch(resetTransactionResponse());
    }
    if (
      transactionStatusLoading === false &&
      transactionStatusRespError != ''
    ) {
      navigate.push('/checkout/confirm');

      //     dispatch(resetInvoiceResponse());
      //dispatch(resetTransactionResponse());
    }
  }, [
    transactionStatusResp,
    transactionStatusLoading,
    transactionStatusRespError,
  ]);

  useEffect(() => {
    if (verifyPaymentResp !== null && paymentStatusLoaded === false) {
      if (
        verifyPaymentResp !== null &&
        verifyPaymentResp.resultStatus === 'TXN_SUCCESS'
      ) {
        console.log("verifyPaymentResp ", verifyPaymentResp);
        paymentAttempCounter = 0;
        const orderId = new URLSearchParams(search).get('orderId');
        //Call generate invoice api here
        const lmrStatus = getLmrChecked();

        paymentRecieveMoengageCall(currentOrderResp);
        const parameters = {
          accessToken,
          payload: {
            storeCode,
            orderId: orderId,
            // redeemLMR:
            //   lmrStatus === null || lmrStatus === false ? false : lmrStatus,
              redeemLMR: false,
          },
        };
        localStorage.removeItem('lmrchecked');
        dispatch(generateInvoice(parameters));
      } else if (
        verifyPaymentResp !== null &&
        verifyPaymentResp.resultStatus === 'TXN_FAILURE'
      ) {
        paymentAttempCounter = 0;

        dispatch(resetInvoiceResponse());
        dispatch(resetTransactionResponse());
        failedPayment(currentOrderResp);
        navigate.push('/checkout/payment_error');
      } else if (
        verifyPaymentResp !== null &&
        verifyPaymentResp.resultStatus != 'TXN_FAILURE' &&
        verifyPaymentResp.resultStatus != 'TXN_SUCCESS'
      ) {
        dispatch(setLoaderRunning(true));
        dispatch(resetInvoiceResponse());
        dispatch(resetTransactionResponse());
        if (paymentAttempCounter === 0) {
          cogoToast.success(
            <InformationToast
              title="Payment procesing"
              description={'Please wait...'}
            />,
            {
              hideAfter: 64,
              renderIcon: () => {
                return null;
              },
            },
          );
        } else if (paymentAttempCounter === 1) {
          cogoToast.success(
            <InformationToast
              title="Payment procesing"
              description={'Please wait, Transaction is processing'}
            />,
            {
              hideAfter: 64,
              renderIcon: () => {
                return null;
              },
            },
          );
        } else if (paymentAttempCounter === 2) {
          cogoToast.success(
            <InformationToast
              title="Payment procesing"
              description={'Please wait, Transaction is still processing'}
            />,
            {
              hideAfter: 64,
              renderIcon: () => {
                return null;
              },
            },
          );
        } else if (paymentAttempCounter === 3) {
          orderId = '';
          checksum = '';
          paymentAttempCounter = 0;
          dispatch(setLoaderRunning(false));
          clearInterval(paymentAttemptTimer);
          navigate.push('/checkout/payment_error');
          return;
        }

        paymentAttemptTimer = window.setInterval(() => {
          if (checksum) {
            clearInterval(paymentAttemptTimer);
            dispatch(setLoaderRunning(false));
            let counter = paymentAttempCounter;
            const parameters = {
              accessToken,
              payload: {
                checksum,
                storeCode,
                orderId,
                verifyPaymentRetryCount: ++counter,
              },
              // access_token: 'test',
            };
            dispatch(verifyPaymentStatus(parameters));
          }
          paymentAttempCounter++;
        }, 65000);
      }
    }
    if (errorInPaymentStatus != '' && paymentStatusLoaded === false) {
      //      console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa');

      dispatch(setLoaderRunning(true));

      if (paymentAttempCounter === 0) {
        cogoToast.success(
          <InformationToast
            title="Payment procesing"
            description={'Please wait...'}
          />,
          {
            hideAfter: 64,
            renderIcon: () => {
              return null;
            },
          },
        );
      } else if (paymentAttempCounter === 1) {
        cogoToast.success(
          <InformationToast
            title="Payment procesing"
            description={'Please wait, Transaction is processing'}
          />,
          {
            hideAfter: 64,
            renderIcon: () => {
              return null;
            },
          },
        );
      } else if (paymentAttempCounter === 2) {
        cogoToast.success(
          <InformationToast
            title="Payment procesing"
            description={'Please wait, Transaction is still processing'}
          />,
          {
            hideAfter: 64,
            renderIcon: () => {
              return null;
            },
          },
        );
      } else if (paymentAttempCounter === 3) {
        dispatch(setPaymentEnableButton(true));
        if (checksum != null) {
          setCheckSum(checksum);
        }

        //setLmrCheck(lmrChecked);
        orderId = '';
        checksum = '';
        paymentAttempCounter = 0;
        dispatch(setLoaderRunning(false));
        clearInterval(paymentAttemptTimer);
        navigate.push('/checkout/payment_error');
        return;
      }
      paymentAttemptTimer = window.setInterval(() => {
        if (checksum) {
          clearInterval(paymentAttemptTimer);
          dispatch(setLoaderRunning(false));
          let counter = paymentAttempCounter;
          if (paymentAttemptStatus) {
            counter = 1;
            paymentAttemptStatus = false;
          }
          const parameters = {
            accessToken,
            payload: {
              checksum,
              storeCode,
              orderId,
              verifyPaymentRetryCount: ++counter,
            },
            // access_token: 'test',
          };
          dispatch(verifyPaymentStatus(parameters));
        }
        paymentAttempCounter++;
      }, 65000);
    }
    dispatch(resetPaymentStatus());
  }, [verifyPaymentResp, errorInPaymentStatus, paymentStatusLoaded]);

  useEffect(() => {
    checksum = new URLSearchParams(search).get('checksum');
    orderId = new URLSearchParams(search).get('orderId');
    if (checksum) {
      const parameters = {
        accessToken,
        payload: {
          checksum,
          storeCode,
          orderId,
          verifyPaymentRetryCount: 0,
        },
        // access_token: 'test',
      };
      dispatch(verifyPaymentStatus(parameters));
    }
  }, []);

  return <></>;
};

export default ProcessPayment;
